import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import { withNamespaces } from 'react-i18next'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'
import i18n from 'Pods/Shared/I18n' // Needed for SSR

import ProductPriceBuyActions from './ProductPriceBuyActions'
import ProductLicense from './ProductLicense'
import ProductActionButton from '../../ProductActionButton/ProductActionButton'

function ProductPriceSaleOff({
  id,
  originalPrice,
  finalPrice,
  saleOffDiscount,
  acceptsPriceOffer,
  isSignedIn,
  hidePriceOffer = false,
  page,
  license,
  title,
  cartItems,
  isDisabled = false,
  isPurchased,
  licenseText,
  t,
}) {
  return (
    <div
      itemProp="offers"
      itemScope=""
      itemType="http://schema.org/Offer"
      className="container-fixed"
    >
      <meta itemProp="priceCurrency" content="USD" />

      <div className="col-12">
        <div className="sticky-container">
          <div className="sticky-price-bar__title">
            {title}
          </div>
          <div className="sticky-price-bar__price">
            <div className="product-pricing__price-row">
              <div className="product-pricing__price" itemProp="price">
                <Tooltip
                  id="vatNotice"
                  content={t('vatNotice')}
                  className={`u-block${isDisabled ? ' is-disabled' : ''}`}
                >
                  {numeral(finalPrice).format('$0.00')}
                </Tooltip>

                {!isPurchased
                && (
                <div className="product-pricing__discount">
                  <span className={`product-pricing__original-price${isDisabled ? ' is-disabled' : ''}`}>
                    {numeral(originalPrice).format('$0.00')}
                  </span>

                  <span className={isDisabled ? 'is-disabled' : ''}>
                    {` ${numeral(-saleOffDiscount).format('0%')}`}
                  </span>
                </div>
                )
                }
              </div>

              {!hidePriceOffer && acceptsPriceOffer && !isPurchased && (
                <Tooltip
                  id="productPriceOfferButton"
                  className="product-pricing__make-offer"
                  tooltipClassName="u-text-center"
                  content="Send your price offer to the author if you want to buy it at lower price."
                >
                  <ProductActionButton
                    classes="btn btn-outline-default"
                    title="Offer price"
                    action="openOfferPriceModal"
                    iconType={['far', 'handshake']}
                    isSignedIn={isSignedIn}
                    itemPrice={finalPrice}
                    itemId={id}
                  />
                </Tooltip>
              )}
            </div>

            <ProductLicense {...license} licenseText={licenseText} />
            {isPurchased && (
              <span className="product-pricing__purchased-note">
                <Icon type={['fal', 'bell']} />
                You have already purchased this item.
              </span>
            )}

            <ProductPriceBuyActions
              id={id}
              price={finalPrice}
              page={page}
              cartItems={cartItems}
              isPurchased={isPurchased}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ProductPriceSaleOff.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  originalPrice: PropTypes.number.isRequired,
  finalPrice: PropTypes.number.isRequired,
  saleOffDiscount: PropTypes.number.isRequired,
  acceptsPriceOffer: PropTypes.bool.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  hidePriceOffer: PropTypes.bool,
  page: PropTypes.string.isRequired,
  license: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  cartItems: PropTypes.array,
  isDisabled: PropTypes.bool,
}

export default withNamespaces('product')(ProductPriceSaleOff)
